var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepicon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 511.99 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1263a9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "step icon 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M414,148.75a10,10,0,0,0,10-10V30A30,30,0,0,0,394,0H30A30,30,0,0,0,0,30V482a30,30,0,0,0,30,30H394a30,30,0,0,0,30-30V408.33a10,10,0,0,0-20,0V482a10,10,0,0,1-10,10H30a10,10,0,0,1-10-10V30A10,10,0,0,1,30,20H394a10,10,0,0,1,10,10V138.75A10,10,0,0,0,414,148.75Z",
    transform: "translate(-0.01)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212,54a92,92,0,0,0-63.12,158.87,9.89,9.89,0,0,0,1.07,1,91.83,91.83,0,0,0,124.09,0,10,10,0,0,0,1.07-1A92,92,0,0,0,212,54Zm0,164a71.61,71.61,0,0,1-43.49-14.67,50,50,0,0,1,87,0A71.62,71.62,0,0,1,212,218Zm-16-76v-6.5a16,16,0,0,1,32,0V142a16,16,0,0,1-32,0Zm73.94,46.68A69.38,69.38,0,0,0,240.48,164,35.81,35.81,0,0,0,248,142v-6.5a36,36,0,0,0-72,0V142a35.81,35.81,0,0,0,7.52,22,69.37,69.37,0,0,0-29.46,24.7,72,72,0,1,1,115.88,0Z",
    transform: "translate(-0.01)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266,438H212a10,10,0,0,0,0,20h54a10,10,0,1,0,0-20Z",
    transform: "translate(-0.01)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266,382H124a10,10,0,0,0,0,20H266a10,10,0,1,0,0-20Z",
    transform: "translate(-0.01)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266,326H124a10,10,0,0,0,0,20H266a10,10,0,1,0,0-20Z",
    transform: "translate(-0.01)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.37,272.93A10,10,0,1,0,91.3,280,10.08,10.08,0,0,0,88.37,272.93Z",
    transform: "translate(-0.01)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.37,328.93A10,10,0,1,0,91.3,336,10.1,10.1,0,0,0,88.37,328.93Z",
    transform: "translate(-0.01)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.37,384.93A10,10,0,1,0,91.3,392,10.1,10.1,0,0,0,88.37,384.93Z",
    transform: "translate(-0.01)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266,270H124a10,10,0,0,0,0,20H266a10,10,0,1,0,0-20Z",
    transform: "translate(-0.01)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M491,130.32a42,42,0,0,0-57.37,15.37l-125.84,218a10,10,0,0,0-1.28,3.89l-8.86,79.34a10,10,0,0,0,15.87,9.16l64.28-47.34a10,10,0,0,0,2.73-3.05l125.84-218A42,42,0,0,0,491,130.32ZM320.06,426.39,324.69,385l28.94,16.71ZM368.21,387l-38.11-22,101-174.91,38.11,22Zm120.84-209.3-9.86,17.07-38.11-22,9.86-17.07a22,22,0,0,1,38.11,22Z",
    transform: "translate(-0.01)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepicon3);
export default __webpack_public_path__ + "static/media/step icon 3.d9e4639d4a33e7a7df1c41d8826c8de5.svg";
export { ForwardRef as ReactComponent };